import React from 'react';
import PropTypes from 'prop-types';
import moment from "moment-timezone";
import { Typography } from "@material-ui/core";
import { getRoutesOfType, calcDurationFromEpoch } from './../../utils/helpers';
import t from "../../languages/pl";
import { typeRoute } from './../../utils/staticData';

const calculateTotalDistance = routes => {
    return routes.reduce((accu, b) => accu + b.dystans, 0);
};

const calculateAverageSpeed = routes => {
    return Math.round(routes.reduce((accu, b) => accu + b.predkosc_sr, 0) / routes.length);
};

const calculateTotalDuration = routes => {
    let durations = routes.map(route => calcDurationFromEpoch(route.data_od, route.data_do));
    let duration = durations.reduce((accu, b) => accu.add(b), moment.duration(0));
    return `${Math.floor(duration.asHours())}${t.hoursAbbreviation} ${duration.get('minutes')}${t.minutesAbbreviation}`;
};

const RoutesSummary = ({ routes, typographyClassName }) => {
    return (
        <React.Fragment>
            <Typography
                className={typographyClassName}
                variant="body2"
            >
                {t.routesDistanceSum}: {calculateTotalDistance(getRoutesOfType(routes, typeRoute))}km
            </Typography>
            <Typography
                className={typographyClassName}
                variant="body2"
            >
                {t.averageRouteSpeed}: {calculateAverageSpeed(getRoutesOfType(routes, typeRoute))}km/h
            </Typography>
            <Typography
                className={typographyClassName}
                variant="body2"
            >
                {t.driveTimeSum}: {calculateTotalDuration(getRoutesOfType(routes, typeRoute))}
            </Typography>
        </React.Fragment>
    );
};

RoutesSummary.propTypes = {
    routes: PropTypes.array,
    typographyClassName: PropTypes.string
};

export default RoutesSummary;
